export default "__VITE_ASSET__21d04591__"